<a class="skip-link" href="#main-content" (click)="skipToContent($event)">Skip to main content</a>
<app-preloader></app-preloader>
<app-navbar></app-navbar>
<main id="main-content" tabindex="-1">
  <router-outlet></router-outlet>
</main>
<app-footer></app-footer>
